import fetch from "unfetch";
import { merge } from "lodash";
import { getAuthCookie } from "../utils/cookie";

const host = process.env.REACT_APP_API_URL;

export const SERVER_METHODS = { GET: "GET", POST: "POST" };
export const requestServer = async (method, path, payload) => {
  // Get region from localStorage or use default "us"
  const region = sessionStorage.getItem("kavida_region") || "";

  let options = { headers: { esid: getAuthCookie() } };
  if (method === SERVER_METHODS.POST) {
    options = merge({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Location-Id": region
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
  } else {
    options = merge({
      method: SERVER_METHODS.GET,
      headers: {
        "X-Location-Id": region
      },
      credentials: 'include',
    });
  }
  let res = await fetch(host + path, options);
  return res;
};

export const requestServerV2 = async (method, path, payload) => {
  const url = path + payload.api_name;
  let options = { headers: { esid: getAuthCookie() } };
  if (method === SERVER_METHODS.POST) {
    options = merge({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(payload.data),
    });
  } else if (method === "PUT") {
    options = merge({
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(payload.data),
    });
  } else if (method === "DELETE") {
    options = merge({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(payload.data),
    });
  } else if (method === "PATCH") {
    options = merge({
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(payload.data),
    });
  } else {
    options = merge({
      method: SERVER_METHODS.GET,
      credentials: 'include',
    });
  }
  let res = await fetch(url, options);
  return res;
};
